import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/Logo";
import { setPostAuth } from "@/lib/askThemes";

function Splash() {
  return (
    <div className="debii-shell flex flex-col items-center justify-center gap-4">
      <div className="animate-pop">
        <LogoMark size={72} />
      </div>
      <div className="h-1 w-24 rounded-full bg-secondary overflow-hidden">
        <div className="h-full w-1/2 bg-primary animate-pulse" />
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { user, sessionEnded } = useAuth();
  const location = useLocation();

  if (user === undefined) return <Splash />;
  if (user === null) {
    const dest = location.pathname + location.search + location.hash;
    if (dest !== "/") setPostAuth(dest);
  }
  if (user === null) return <Navigate to={sessionEnded ? "/auth?mode=login" : "/welcome"} replace />;
  // Force first-name capture right after registration
  if (!user.name && location.pathname !== "/setup-name")
    return <Navigate to="/setup-name" replace />;
  return children;
}
